import { render, staticRenderFns } from "./BonusEngineRule.vue?vue&type=template&id=6fbc7004&scoped=true&"
import script from "./BonusEngineRule.vue?vue&type=script&lang=js&"
export * from "./BonusEngineRule.vue?vue&type=script&lang=js&"
import style0 from "./BonusEngineRule.vue?vue&type=style&index=0&id=6fbc7004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc7004",
  null
  
)

export default component.exports